import * as React from 'react';
import styled from 'styled-components';

import { AppBar, Toolbar, Hidden, IconButton } from '@material-ui/core';
import IconMenu from '@material-ui/icons/Menu';

interface HeaderProps {
  onToggle?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  isCollapsed: boolean;
}

const StyledAppBar = styled(AppBar)`
  box-shadow: none;
`;
const StyledIconButton = styled(IconButton)`
  color: white;
  margin-left: 0px;
`;

const Header = ({ onToggle }: HeaderProps) => {
  return (
    <StyledAppBar position='absolute'>
      <Toolbar>
        <Hidden smUp>
          <img
            src={process.env.PUBLIC_URL + '/assets/logos/logo-white.png'}
            alt='Sloan Longway logo'
            width='150'
          />
        </Hidden>
        <Hidden xsDown>
          <img
            src={process.env.PUBLIC_URL + '/assets/logos/logo-white.png'}
            alt='Sloan Longway logo'
            width='180'
          />
        </Hidden>
        <StyledIconButton
          edge='start'
          aria-label='Toggle sidebar'
          onClick={onToggle}
          data-cy='sidebar_menuExpandCollapse'
        >
          {/* {isCollapsed ? <IconMenu fontSize="large" /> : <CloseMenu fontSize="large" />} */}
          <IconMenu fontSize='large' />
        </StyledIconButton>
      </Toolbar>
    </StyledAppBar>
  );
};

export default Header;
